import Image from '@tiptap/extension-image'
import {
  mergeAttributes,
} from '@tiptap/core'

export default Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      radius: {
        default: 15,
        renderHTML: attributes => {
          return {
            style: `border-radius: ${attributes.radius}%`
          }
        },
        parseHTML: element => ({
          radius: element.style.borderRadius.replace(/%/g, '') || 15
        })
      },
      textAlign: {
        default: 'center',
        renderHTML: attributes => {
          return {
            style: `text-align: ${attributes.textAlign}`
          }
        },
        parseHTML: element => ({
          textAlign: element.style.textAlign || 'center'
        })
      },
      mediaObjectId: {
        default: '',
        renderHTML: attributes => {
          return {
            mediaObjectId: attributes.mediaObjectId,
          }
        },
      },
      fullMode: {
        default: false,
        renderHTML: attributes => {
          let mql = window.matchMedia('(max-width: 600px)');
          let maxHeight = "50vh"
          if (mql.matches) {
            maxHeight = "70vh"
          }
          return {
            style: attributes.fullMode ? `max-height: ${maxHeight}; width: 100%; object-fit: cover` : null
          }
        },
        parseHTML: element => (
          {
            fullMode: element.style.width == `100%`          
          })
      },
      fitMode: {
        default: true,
        renderHTML: attributes => {
          return {
            style: attributes.fitMode ? `max-width: 50%` : null
          }
        },
        parseHTML: element => (
          {
            fitMode: element.style.maxWidth == `50%`,
          })
      },
    }
  },
  parseHTML() {
    return [
      {
        tag: 'div > img[src]',
      },
    ]
  },
  renderHTML({ HTMLAttributes, node: { attrs } }) {
    let containerStyle = "max-width: 100%;";
    if (attrs.textAlign) {
      containerStyle += `text-align: ${attrs.textAlign}`
    }
    return ['div', mergeAttributes({ style: containerStyle }), ['img', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)]]
  },
  addCommands() {
    return {
      setImage: options => ({ commands }) => {
        return commands.insertContent({
          type: this.name,
          attrs: options,
        })
      },
      setImageMediaObjectId: id => ({ commands }) => {
        commands.updateAttributes(this.name, { mediaObjectId: id })
      },
      setImageSrc: src => ({ commands }) => {
        commands.updateAttributes(this.name, { src: src })
      },
      setRadius: (radius) => ({ commands }) => {
        commands.updateAttributes(this.name, { radius: radius })
      },
      setFitMode: () => ({ commands }) => {
        commands.updateAttributes(this.name, { fitMode: true, fullMode: false, })
      },
      setFullMode: () => ({ commands }) => {
        commands.updateAttributes(this.name, { fitMode: false, fullMode: true, })
      },
    }
  },
})